'use client'

import { InspirationalClientLink } from '@fukku/button/ClientLink/Inspirational/InspirationalClientLink'
import { useTransparentProps } from 'header-utils/context/TransparentPropsContext/useTransparentProps'
import { IconAccountL } from 'icons/components/IconAccountL'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { MyAccountClientLinkProps } from 'links/myAccount/client'
import { type ForwardedRef, forwardRef } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import iconStyles from '../components/Icons.module.scss'
import { DataTestIds } from '../constants/testIds'
import { useAccountLink } from '../hooks/useAccountLink'

export const AccountLink = forwardRef<HTMLAnchorElement>(
	(_, ref?: ForwardedRef<HTMLAnchorElement>) => {
		const { isLargeOrGreater } = useResponsive()
		const { t } = useLabels()
		const { iconColor, inspirationalVariant } = useTransparentProps()
		const { text, accessibilityText, Component } = useAccountLink()

		const linkProps: MyAccountClientLinkProps['linkProps'] = {
			ref,
			rel: 'nofollow',
			'aria-label': t(accessibilityText),
			'data-testid': isLargeOrGreater
				? DataTestIds.IconLarge
				: DataTestIds.IconSmall,
		}

		return (
			<Component
				className={iconStyles.link}
				linkProps={linkProps}
				linkComponent={isLargeOrGreater ? InspirationalClientLink : undefined}
				variant={inspirationalVariant}
			>
				<IconAccountL className={iconStyles.icon} color={iconColor} />
				<span className={iconStyles.text}>{text}</span>
			</Component>
		)
	}
)
